
namespace RioERP.Masters {
    export class CoursesColumns {
        static columnsKey = 'Masters.Courses';
    }
}